module.exports = __webpack_public_path__ + "img/zip.2fcf892e.svg";